var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcnIconVacios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.537,
    height: 58.457,
    viewBox: "0 0 40.537 58.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_105",
    "data-name": "Union 105",
    d: "M11.331,57.457V39.675h5.09l3.414-6.311a5.188,5.188,0,0,1-2.573-1,5.277,5.277,0,0,1-1.991-5.08l1.278.2a3.986,3.986,0,0,0,1.49,3.844,3.881,3.881,0,0,0,4.719-.056,3.768,3.768,0,0,0,1.294-2.759,3.826,3.826,0,0,0-1.032-2.864,3.872,3.872,0,0,0-2.843-.95l-.678.033V22.2H17.614V20.908H19.5V19.562H15.856a3.7,3.7,0,0,1-3.694-3.692V14.192H6.641V8.642H32.9v5.55h-4.69V15.87a3.7,3.7,0,0,1-3.693,3.692h-3.72v1.346h1.864V22.2H20.793v1.22a4.9,4.9,0,0,1,3.135,1.311,5.138,5.138,0,0,1,1.416,3.839,5.067,5.067,0,0,1-1.758,3.7,4.92,4.92,0,0,1-2.532,1.08L24.4,39.675h4.862V57.457Zm1.293-1.293H27.972V40.969H12.625Zm5.267-16.489h5.048l-2.5-4.716Zm-4.436-23.8a2.4,2.4,0,0,0,2.4,2.4h8.656a2.4,2.4,0,0,0,2.4-2.4V14.192H13.456ZM7.934,12.9H31.6V9.935H7.934ZM21.885,52.616V51.323H24.76v1.293Zm-5.748,0V51.323h2.874v1.293Zm5.748-5.938V45.386H24.76v1.292Zm-5.748,0V45.386h2.874v1.292ZM0,8.027V0H39.537V8.027ZM31.939,6.733h6.3V1.294h-6.3Zm-7.792,0h6.5V1.294h-6.5Zm-7.728,0h6.434V1.294H16.418Zm-7.532,0h6.238V1.294H8.886Zm-7.593,0h6.3V1.294h-6.3Z",
    transform: "translate(0.5 0.5)",
    fill: "#223466",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcnIconVacios);
export default __webpack_public_path__ + "static/media/mcn_icon_vacios.3e47ac8a91fdfc27772863bdbddbb6fb.svg";
export { ForwardRef as ReactComponent };